import { getStoredToken } from '../authApi';

import { getServerUrl } from '../updateChannel';
const MATCHMAKING_URL = () => getServerUrl();

async function authHeaders() {
  const token = await getStoredToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchInbox() {
  const res = await fetch(`${MATCHMAKING_URL()}/mail/inbox`, {
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch inbox');
  return res.json();
}

export async function sendMail({ recipientId, subject, body, cards, coins }) {
  const res = await fetch(`${MATCHMAKING_URL()}/mail/send`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ recipientId, subject, body, cards, coins }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to send mail');
  }
  return res.json();
}

export async function markMailRead(mailId) {
  const res = await fetch(`${MATCHMAKING_URL()}/mail/${encodeURIComponent(mailId)}/read`, {
    method: 'POST',
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to mark mail read');
  return res.json();
}

export async function claimMail(mailId) {
  const res = await fetch(`${MATCHMAKING_URL()}/mail/claim`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ mailId }),
  });
  if (!res.ok) throw new Error('Failed to claim mail');
  return res.json();
}

export async function deleteMail(mailId) {
  const res = await fetch(`${MATCHMAKING_URL()}/mail/${encodeURIComponent(mailId)}`, {
    method: 'DELETE',
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to delete mail');
  if (res.status === 204) return null;
  return res.json().catch(() => null);
}

/**
 * Fetch the server's unread summary. The server returns
 *   { count, byType: { friend, auction, news }, chatUnread }
 * where `count` is total unread mail (for backwards-compat callers),
 * `byType` breaks it down per Mailbox tab, and `chatUnread` is the
 * total unread chat-message count across every friend. `draft-invite`
 * mails are folded into `byType.friend` server-side so the Social
 * tab's badge matches its contents. Older servers may only return
 * `{ count }`. We normalise those responses so UI code can rely on
 * the full shape.
 */
export async function getUnreadCount() {
  const res = await fetch(`${MATCHMAKING_URL()}/mail/unread-count`, {
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to get unread count');
  const data = await res.json();
  return {
    count: data?.count || 0,
    byType: {
      friend: data?.byType?.friend || 0,
      auction: data?.byType?.auction || 0,
      news: data?.byType?.news || 0,
    },
    chatUnread: data?.chatUnread || 0,
  };
}
